import PaymentFailureTemplate from "../../../Templates/Main/Reservation/PaymentFailure.Template"

const PaymentFailurePage = ({t}) => {
    return (
        <PaymentFailureTemplate t={t}/>
    )
}
 
export default PaymentFailurePage